import React from "react";
import {
    Typography,
    Paper,
    Link,
    Tooltip,
} from "@mui/material";
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from "@mui/lab";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LaunchIcon from "@mui/icons-material/Launch";
import { motion } from "framer-motion";

const publications = [
    {
        title: 'Microservices Architecture for Optimizing Warehouse Management Systems in Global Supply Chains',
        journal: 'Journal of Artificial Intelligence and Machine Learning',
        year: 2023,
        abstract: 'This paper discusses the implementation of microservices architecture to enhance the efficiency of warehouse management systems in global supply chains...',
        link: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=4LOFMeQAAAAJ&citation_for_view=4LOFMeQAAAAJ:IjCSPb-OGe4C',
    },
    {
        title: 'Digital Twin Technology for Real-Time Simulation and Optimization of Warehouses',
        journal: 'North American Journal of Engineering Research',
        year: 2023,
        abstract: 'Exploring the use of digital twin technology to create real-time simulations for optimizing warehouse operations...',
        link: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=4LOFMeQAAAAJ&citation_for_view=4LOFMeQAAAAJ:2osOgNQ5qMEC',
    },
    {
        title: 'A Continuous Integration and Deployment Framework for Sagemaker Real-Time Inference',
        journal: 'Journal of Artificial Intelligence and Machine Learning',
        year: 2024,
        abstract: 'A deployment framework for sagemaker real time inference',
        link: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=4LOFMeQAAAAJ&citation_for_view=4LOFMeQAAAAJ:qjMakFHDy7sC',
    },
    {
        title: 'Distributed Ledger Technology for Transparent and Secure Warehouse Inventory Tracking',
        journal: 'Journal of Current Science and Research Review',
        year: 2025,
        abstract: 'Use of distributed ledgers to securely transmit inventory movement data across warehouse management systems',
        link: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=4LOFMeQAAAAJ&citation_for_view=4LOFMeQAAAAJ:2osOgNQ5qMEC',
    },
];

const Publications: React.FC = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <Typography variant="h4" color="primary" gutterBottom>
                Publications
            </Typography>

            <Timeline position="alternate">
                {publications.map((pub, index) => (
                    <TimelineItem key={index}>
                        <TimelineOppositeContent
                            sx={{ m: "auto 0" }}
                            align="right"
                            variant="body2"
                            color="text.secondary"
                        >
                            {pub.year}
                        </TimelineOppositeContent>

                        <TimelineSeparator>
                            <TimelineDot color="primary">
                                <MenuBookIcon />
                            </TimelineDot>
                            {index < publications.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>

                        <TimelineContent sx={{ py: 2 }}>
                            <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
                                <Typography variant="h6" component="span">
                                    {pub.title}
                                </Typography>
                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                    {pub.journal}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    {pub.abstract}
                                </Typography>
                                <Tooltip title="View on Google Scholar">
                                    <Link
                                        href={pub.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
                                    >
                                        <LaunchIcon fontSize="small" />
                                        View on Google Scholar
                                    </Link>
                                </Tooltip>
                            </Paper>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </motion.div>
    );
};

export default Publications;
